import { DocumentNode, MutationHookOptions } from '@apollo/client'
import {
  UpdateSessionAttendancesDocument,
  UpdateSessionAttendancesMutation,
  UpdateSessionAttendancesMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateSessionAttendancesMutation,
  UpdateSessionAttendancesMutationVariables
> & {
  refetchQueries: DocumentNode[]
}

export const useUpdateSessionAttendances = (options: Options) => {
  const { refetchQueries, ...mutationOptions } = options

  const [updateSessionAttendances, { loading }] = useMutation(UpdateSessionAttendancesDocument, {
    ...mutationOptions,
    extractorFn: (data) => data.trainingsMutations.bulkUpdateTrainingsSessionAttendance,
  })

  return {
    loading,
    updateSessionAttendances(variables: UpdateSessionAttendancesMutationVariables) {
      return updateSessionAttendances({
        variables,
        awaitRefetchQueries: true,
        refetchQueries,
      })
    },
  }
}
